import SyncGroupList from "./SyncGroupList";

const SyncQueueList = () => <SyncGroupList />;

export default SyncQueueList;
